<script lang="ts">
	import type { Device } from 'src/types/Device';
	import SensorPriorityView from 'src/components/Sidepanel/DeviceViews/Sensor/SensorPriorityView.svelte';

	export let device: Device;
</script>

<SensorPriorityView {device} />
